<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!--
  <v-select v-model="configName"
              :items="configNames"
              :label="labelSearch"
              @change="checkSelection"
              persistent-hint
              return-object
              single-line
    ></v-select>
    </div>
    -->

  <div class="text-center">
    <span>
      {{'TITLE_KONFIGURATION' | translate}}</span>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="text-none"
          color="#004884"
          small
          flat
          round
        >
          {{configName}}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-for="(item, index) in configNames"
          :key="index"
          v-model="configName"
          @click="setItem(item)"
        >
          <v-list-tile-title>
            {{ item }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>


</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'SelectConfigurationList',
    components: {},
    return: {},
    props: ['name'],
    methods: {
      checkSelection: function () {
        this.$emit('input', this.configName)
        this.$emit('change', this.configName)
      },
      updateConfigNameFromDialog: function (name) {
        console.log('updateConfigNameFromDialog', name)
        Vue.prototype.storage.setConfigName(this.name, name)
      },
      setItem: function (item) {
        this.configName = item
        Vue.prototype.storage.setConfigName(this.name, this.configName)
        this.checkSelection()
      },
      getConfigName: function () {
        return this.configName
      },
      onGetConfigurationList: function (data) {
        this.configNames = this.configNames.concat(data)
        if (this.configNames.indexOf(Vue.prototype.storage.getConfigName(this.name)) > -1) {
          this.configName = Vue.prototype.storage.getConfigName(this.name)
        } else {
          // console.log('cn not found', Vue.prototype.storage.getConfigName(), this.configNames)
        }
      },
      load: function (data) {
        this.rk = data.rk
        this.guvNr = data.guvNr
        this.configNames = [Vue.i18n.translate('LABEL_CONFIG_DEFAULT')]
        Vue.prototype.$api.getConfigurationList(this.rk, this.guvNr, this.onGetConfigurationList)
      },
      reset: function () {
        // this.configName = Vue.i18n.translate('LABEL_CONFIG_DEFAULT')
        // Vue.prototype.storage.setConfigName(this.configName)
      },
      reload: function (data, cName) {
        var cmp = this
        var d = {
          rk: cmp.rk,
          guvNr: cmp.guvNr
        }
        if (data) {
          d = data
        }
        if (cName) {
          this.configName = cName
        }
        this.load(d)
      }
    },
    data() {
      return {
        configName: Vue.i18n.translate('LABEL_CONFIG_DEFAULT'),
        configNames: [Vue.i18n.translate('LABEL_CONFIG_DEFAULT')],
        labelSearch: Vue.i18n.translate('LABEL_CONFIG_SELECTION'),
      }
    },
    created() {
      Vue.prototype.$eventHub.$on('loadConfigurationList', this.load)
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('loadConfigurationList', this.load)
    },
    mounted() {
      //
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/SelectConfigurationList.vue